
/* ==============================================
ヘッダーの部分
============================================== */
document.addEventListener("DOMContentLoaded", () => {
  const drawerIcon = document.querySelector(".drawerIcon");
  const drawer = document.querySelector(".drawer");
  const drawerNavItem = document.querySelectorAll('.drawer a[href^="#"]');

  const breakpoint = 768;

  // アニメーション中判定
  let isAnimating = false;
  let closeTimer = null;

  // 開く
  const openMenu = () => {
    if (isAnimating) return;

    isAnimating = true;
    clearTimeout(closeTimer);

    drawer.classList.remove("is-closing");

    drawer.classList.add("js-show");
    drawerIcon.classList.add("js-show");

    document.body.classList.add("is-lock");

    setTimeout(() => {
      isAnimating = false;
    }, 500);
  };

  // 閉じる
  const closeMenu = () => {
    if (isAnimating) return;

    isAnimating = true;

    drawer.classList.add("is-closing");
    drawerIcon.classList.remove("js-show");

    setTimeout(() => {
      drawer.classList.remove("js-show");
      drawer.classList.remove("is-closing");

      document.body.classList.remove("is-lock");

      isAnimating = false;
    }, 500);
  };

  // 開閉
  const toggleMenu = () => {
    if (isAnimating) return;

    if (drawer.classList.contains("js-show")) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  // リサイズ
  const handleResize = () => {
    if (window.innerWidth > breakpoint) {
      closeMenu();
    }
  };

  // 外クリック
  const clickOuter = (event) => {
    if (drawer.classList.contains("js-show") && !drawer.contains(event.target) && !drawerIcon.contains(event.target)) {
      closeMenu();
    }
  };

  // ハンバーガー
  drawerIcon.addEventListener("click", toggleMenu);

  // リサイズ
  window.addEventListener("resize", handleResize);

  // 外クリック
  document.addEventListener("click", clickOuter);

  // 新・スクロール関数（.drawerScrollの中を動かす仕様）
  const linkScroll = (target) => {
    if (!target) return;

    // スクロールさせる全体の器（.drawerScroll）を取得
    const scrollContainer = document.querySelector(".drawerScroll") || window;

    if (scrollContainer === window) {
      // 万が一コンテナがない場合のフォールバック
      const targetPosition = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    } else {
      // .drawerScroll の中をスクロールさせる
      const containerTop = scrollContainer.getBoundingClientRect().top;
      const targetTop = target.getBoundingClientRect().top;
      // 現在のスクロール位置 + ターゲットの相対位置
      const scrollTarget = scrollContainer.scrollTop + (targetTop - containerTop);

      scrollContainer.scrollTo({
        top: scrollTarget,
        behavior: "smooth",
      });
    }
  };

  // 新・ページ内リンクのクリックイベント
  drawerNavItem.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();

      const targetItem = document.querySelector(item.getAttribute("href"));

      // 1. まずドロワーを閉じる（アニメーション開始。ここでbodyのlock解除などが予約されます）
      closeMenu();

      // 2. ドロワーが閉じるアニメーション（500ms）が終わるのを待ってからスクロール
      setTimeout(() => {
        linkScroll(targetItem);
      }, 50);
    });
  });
});

export function scrImgFunc() {
  const scroll = document.querySelector("#js-images-scroll");
  const images = document.querySelector("#js-images");

  if (!scroll || !images) return;

  // 追加したい複製数
  const cloneCount = 2;

  const clones = [];

  for (let i = 0; i < cloneCount; i++) {
    const clone = images.cloneNode(true);

    clone.removeAttribute("id");

    scroll.appendChild(clone);

    clones.push(clone);
  }

  const setup = () => {
    const items = [...images.children];

    let maxRight = 0;

    items.forEach((item) => {
      const width = item.offsetWidth;

      maxRight = Math.max(maxRight, width);
    });

    images.style.setProperty("--images-width", `${maxRight}px`);

    clones.forEach((clone) => {
      clone.style.setProperty("--images-width", `${maxRight}px`);
    });

    scroll.style.setProperty("--images-width", `${maxRight}px`);
  };

  setup();

  window.addEventListener("resize", setup);
}